import { useMutation } from "@apollo/client";
import { DELETE_PAYMENT } from "../apollo/mutations"; // Define DELETE_PAYMENT mutation in your Apollo configuration.

const useDeletePayment = (refetch, refetchCustomers) => {
  const [deletePayment, { loading, error }] = useMutation(DELETE_PAYMENT);

  const handleDeletePayment = async (deletePaymentId) => {
    try {
      await deletePayment({
        variables: { deletePaymentId: deletePaymentId }, // Adjust the variable name based on your backend schema.
      });
      await refetch();
      refetchCustomers()
      console.log("Payment deleted successfully.");
    } catch (err) {
      console.error("Error deleting payment:", err.message);
    }
  };

  return {
    handleDeletePayment,
    loading,
    error,
  };
};

export default useDeletePayment;